import { render, staticRenderFns } from "./widgetVideo.vue?vue&type=template&id=6658980d&scoped=true"
import script from "./widgetVideo.vue?vue&type=script&lang=js"
export * from "./widgetVideo.vue?vue&type=script&lang=js"
import style0 from "./widgetVideo.vue?vue&type=style&index=0&id=6658980d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658980d",
  null
  
)

export default component.exports